module.exports = __webpack_public_path__ + "media/images/logo/niet_gebruikt/acutezorg-cc5c4e1b0ccd407b50ec05fc06f621f5.svg";